<template>
  <div />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage.vue'

export default {
  name: 'AbstractHomePage',

  extends: AbstractPage,

  /**
   *
   */
  created() {
    this.$store.dispatch('configuration/resetLandingPage')
  },
}
</script>
